import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasProgressComponent } from './gas-progress.component';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';

const COMPONENT = [
  GasProgressComponent,
];

@NgModule({
  declarations: [
    COMPONENT,
  ],
  exports: [
    COMPONENT,
  ],
  imports: [
    CommonModule,
    GasIconsModule,
  ],
})
export class GasProgressModule { }
